export * from './BaseTextRenderer.module.scss';
export * from './BaseTextRenderer';